import { render } from "./UploadView.vue?vue&type=template&id=48b1ef94&scoped=true"
import script from "./UploadView.vue?vue&type=script&lang=js"
export * from "./UploadView.vue?vue&type=script&lang=js"

import "./UploadView.vue?vue&type=style&index=0&id=48b1ef94&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Antonio\\Desktop\\model-viewer-generator_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b1ef94"]])

export default __exports__